import React from 'react';
import { Link } from 'react-router-dom';

export default function ScheduleCall() {
  return (
    <div className="bg-gradient-to-br from-black to-blue-950 text-white min-h-screen py-20 px-6">
      <div className="max-w-4xl mx-auto space-y-8 text-center">
        <p className="text-xs uppercase tracking-[0.6em] text-white/70">Schedule a Call</p>
        <h1 className="text-4xl font-bold">Pick a time with our lead strategist</h1>
        <p className="text-white/80">
          Share your timezone and we’ll send a Calendly link with pre-filled firm details. All calls include prep notes and a strategy worksheet.
        </p>
        <div className="grid gap-4 text-left text-sm text-white/80 md:grid-cols-2">
          <div className="rounded-2xl bg-white/10 p-6">
            <p className="text-xs uppercase tracking-[0.4em] text-white/60">Next available</p>
            <p className="mt-2 text-xl font-semibold">Monday · 3:00 PM ET</p>
            <p>Virtual or in-person by request.</p>
          </div>
          <div className="rounded-2xl bg-white/10 p-6">
            <p className="text-xs uppercase tracking-[0.4em] text-white/60">Prep</p>
            <p className="mt-2 text-white">Link to PDF questionnaire emailed instantly after you submit.</p>
          </div>
        </div>
        <Link
          to="/free-assessment"
          className="inline-flex items-center justify-center rounded-full bg-accent px-6 py-3 text-sm font-semibold text-charcoal shadow-lg shadow-accent/40"
        >
          Reserve a slot
        </Link>
      </div>
    </div>
  );
}
